import React from "react";
import ToggleSwitch from "../ToggleSwitch";

// Toggles the processed view between all rows and error rows only.
// Backed by a single boolean: showErrorRows false = all rows, true = error rows.
const SubmissionErrorRowToggle = ({ showErrorRows, setShowErrorRows }) => (
  <ToggleSwitch checked={showErrorRows} onChange={setShowErrorRows} label="Show Alert Rows" />
);

export default SubmissionErrorRowToggle;
